import script from "./GoldRechargeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GoldRechargeDialog.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/GoldRechargeDialog.css?vue&type=style&index=0&id=8ac47af0&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ac47af0"]])

export default __exports__